module.exports = __webpack_public_path__ + "img/not-read.c67cd9a0.svg";